import React from 'react';

import styles from './hoverOverTooltipStyles';

import TooltipWhite from 'buyside/components/presentation/Tooltips/TooltipWhite/tooltipWhite';

const HoverOverTooltip = ({ children, overlay, trigger = ['hover'], className = '' }) => {
  return (
    <div className={styles.hoverOverTooltip + ` ${className}`}>
      <TooltipWhite overlay={overlay} trigger={trigger}>
        <div className={styles.hoverOverTooltipInside}>{children}</div>
      </TooltipWhite>
    </div>
  );
};

export default HoverOverTooltip;
